import $ from 'jquery'

$(window).on('load resize', function() {
  var button = $('.o-newsletter').find('button')

  if ($(window).width() <= 767) {
    button.text("s'inscrire")
  } else {
    button.text('me tenir informé')
  }
})

$(document).ready(function() {
  var block, toggleBurger, toggleButton, menu, search

  $('.o-header__menuMobile').each(function() {
    block = $(this)
    toggleBurger = block.find('.o-header__menuMobile__button')
    menu = $('.o-header__content')

    toggleBurger.on('click', function() {
      $(this).toggleClass('open')
      menu.slideToggle(400)
    })

    $(window).on('load resize', function() {
      if ($(window).width() <= 1023) {
        menu.hide()
      } else {
        menu.show()
      }
    })
  })

  $('.o-blog-content').each(function() {
    block = $(this)
    toggleButton = block.find('.o-filter')
    search = block.find('.o-actualites__search')

    toggleButton.on('click', function() {
      $(this).toggleClass('opened')
      search.slideToggle(400)
    })

    $(window).on('load resize', function() {
      if ($(window).width() <= 767) {
        search.hide()
      } else {
        search.show()
      }
    })
  })
})

$(document).ready(function() {
  var header = $('.o-header')
  var fixedMenu = $('.o-header__menuContainer')
  var fixedMenuMobile = $('.o-header__menuMobile')
  var hauteurMenuMobile = fixedMenuMobile.height()
  var sousMenu = $('.o-header__content')

  $(window).on('load scroll', function() {
    var offset = $(this).scrollTop()
    if ((offset >= 1) & ($(window).width() >= 1023)) {
      fixedMenu.addClass('sticky')
    } else if ((offset >= 0) & ($(window).width() <= 1023)) {
      fixedMenuMobile.addClass('sticky')
      sousMenu.css({ top: hauteurMenuMobile + offset, zIndex: '1' })
    } else {
      fixedMenu.removeClass('sticky')
      fixedMenuMobile.removeClass('sticky')
      sousMenu.css({ top: '63px' })
    }
  })

  $(window).on('load scroll', function() {
    var offset = $(this).scrollTop()
    if ((offset >= header.outerHeight() - fixedMenu.outerHeight()) & ($(window).width() >= 1023)) {
      fixedMenu.addClass('background')
    } else {
      fixedMenu.removeClass('background')
    }
  })

  // faire disparaitre les elements progressivement au scroll

  var fadeStart = 0
  var fadeUntil = fixedMenu.height() + 100
  var fading = $('.fading')

  $(window).on('scroll', function() {
    var offset = $(document).scrollTop()
    var opacity = 0

    if (offset <= fadeStart) {
      opacity = 1
    } else if (offset <= fadeUntil) {
      opacity = 1 - offset / fadeUntil
    }
    fading.css('opacity', opacity)
  })

  if ($('#mjForm').length) {
    $('#mjForm').on('submit', function() {
      $(this).find("[type='submit']").prop('disabled', true)
    })

    if ($('#mjForm').next().html() !== '') {
      let text = $('#mjForm').next().html()

      $('.message-mailjet').append(text)
      $('.message-mailjet').addClass('text-margin')
    }
  }

  if ($('.o-sharing-mail').length) {
    $('.o-sharing-mail').click(function () {
      let title = $(this).data('title')
      let link = $(this).data('link')

      let email = ''
      let subject = 'Deeptinvest - ' + title
      let emailBody = 'Je vous invite à lire un article du blog de Deeptinvest sur ' + title + ' en cliquant sur ce lien :%0D%0A%0D%0A ' + link + ' '
      document.location = 'mailto:' + email + '?subject=' + subject + '&body=' + emailBody
    })
  }
})

// ADD BLOCK SUBMENUCONTAINER AND CLASS LINKTITLE IN HEADER MENU

$(document).ready(function() {
  $('.sub-menu').wrap('<div class="sub-menu__container"></div>')
  var submenuContainer = $('.sub-menu__container')
  var link = submenuContainer.siblings()
  link.addClass('o-linkTitle')

  $('.list').each(function() {
    var block = $(this)
    var slideToShow = block.find('.sub-menu')
    var linkTitle = block.find('.o-linkTitle')

    block.on('click', function() {
      if ($(window).width() <= 1023) {
        linkTitle.toggleClass('active')
        slideToShow.toggleClass('open')
        slideToShow.slideToggle(400)
      }
    })
  })
})



// Newsletter
// $( document ).on( 'submit', '#mjForm', function(e) {
//   e.preventDefault();
//   $.ajax({
//     url : ajaxurl,
//     method : 'POST',
//     data : {
//       action : 'newsletter',
//       email : $(this).find('[type="email"]').val()
//     },
//     success : function( data ) {
//       if ( data.success ) {
//         $('#message_newsletter').show()
//       }
//     },
//     error : function( data ) {
//       console.log( 'Erreur…' );
//     }
//   });
// });
